/**
 * IMPORTS
 */

import { Link } from "react-router-dom";

import { Card } from "@components/card/card";

import { useStoreZustandModelosCliente } from "@/store-zustand/cliente/details-modelo";

// types
import type { IModeloUnicoProps } from "@/store-zustand/cliente/details-modelo/index.d";

// components
import { ModelImage } from "../modelo-image";


interface IModelCard {
  item: IModeloUnicoProps;
}


function ModeloCard({ item }: IModelCard) {
  const { setModeloUnico, clearPersistedData } = useStoreZustandModelosCliente();

  const emAndamento = item?.modeloCompleto?.remessas_em_andamento ?? 0;
  const totalProduzido = item?.modeloCompleto?.total_remessas_produzidas ?? 0;

  return (
    <Link
      to="/details-model"
      onClick={() => {
        clearPersistedData();
        setModeloUnico(item);
      }}
      className="group block min-w-0 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 motion-reduce:transition-none"
    >
      <Card className="overflow-hidden p-0 shadow-sm transition-shadow duration-200 group-hover:shadow-md md:p-0 lg:p-0 motion-reduce:transition-none">
        <div className="border-b px-3 py-2">
          <h2 className="line-clamp-1 min-w-0 text-sm font-semibold text-gray-800">
            {item?.nome_modelo ?? "Modelo sem nome"}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-2 p-3">
          <ModelImage src={item?.foto_frente_path} alt={`Frente do modelo ${item?.nome_modelo}`} />
          <ModelImage src={item?.foto_verso_path} alt={`Verso do modelo ${item?.nome_modelo}`} />
        </div>

        <div className="flex gap-1.5 px-3 pb-3 text-xs">
          <div className="flex min-w-0 flex-1 items-center justify-between rounded bg-amber-500 px-2 py-1 text-white">
            <span className="truncate">Em andamento</span>
            <span className="ml-1 shrink-0 font-semibold tabular-nums">{emAndamento}</span>
          </div>
          <div className="flex min-w-0 flex-1 items-center justify-between rounded bg-blue-600 px-2 py-1 text-white">
            <span className="truncate">Total</span>
            <span className="ml-1 shrink-0 font-semibold tabular-nums">{totalProduzido}</span>
          </div>
        </div>
      </Card>
    </Link>
  );
}


/**
 * EXPORT
 */
export { ModeloCard };